import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef,
} from 'react';

import { 
  getFromURI
} from './IpfsApp';

import {
BrowserRouter as Router,
Route,
Link,
Routes
} from "react-router-dom";

import styled from 'styled-components';
import { Provider } from '../utils/provider';

import { Row, Col, Card, Button, Form } from 'react-bootstrap';

//CFP LIVE
import CFP_Artifact from '../live_artifacts/contracts/CosmicForcePaydirt.sol/CosmicForcePaydirt.json';
import CFP_Address from '../live_artifacts/contracts/CosmicForcePaydirt.sol/CosmicForcePaydirt-address.json';

//MEGA PAYDIRT NFT
import CosmicForcePaydirtNFTArtifact from '../live_artifacts/contracts/CosmicForcePaydirtNFT.sol/CosmicForcePaydirtNFT.json';
import CosmicForcePaydirtNFTAddress from '../live_artifacts/contracts/CosmicForcePaydirtNFT.sol/CosmicForcePaydirtNFT-address.json';

const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function PaydirtNFTApp(): ReactElement {
  return (
    <StyledAppDiv>
      <MegaMiningClaimContract />
    </StyledAppDiv>
  );
}

export function MegaMiningClaimContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [NFTContract, setNFTContract] = useState<Contract>();
  const [NFTContractAddr, setNFTContractAddr] = useState<string>('');

  const [image, setImage] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const reffirstRef = useRef(null);

  const [nftTokenName, setTokenName] = useState<string>('');
  const [nftTokenSymbol, setTokenSymbol] = useState<string>('');
  const [nftTokenOwner, setTokenOwner] = useState<string>('');
  const [approveAmountInput, setApproveAmountInput] = useState<string>('');
  const [buySTACKCOREButton, setBuyCFALPHAButton] = useState<string>('APPROVE BUSD & MINT $STACKCORE NFT');
  const [buyPLANETDUALButton, setBuyPlanetDUALButton] = useState<string>('LOADING DUAL STACK CORES');
  const [buyPLANETDUALButton2, setBuyPlanetDUALButton2] = useState<string>('LOADING DUAL STACK CORES');

  const [totalBUSDRaised, setTotalBUSDRaised] = useState(0);
  const [totalCFPRaised, setTotalCFPRaised] = useState(0);
  const [busdBalance, setbusdBalance] = useState(0);
  const [safuuBalance, setsafuuBalance] = useState(0);
  const [totalNFTSupply, setTotalNFTSupply] = useState(0);
  const [totalMinted, setTotalMinted] = useState(0);


  const [nbrAlpha, setNbrAlpha] = useState<string>(''); // Alpha  NFT's
  const [nbrOG, setNbrOG] = useState<string>(''); // OG NFT's

  const [paydirtNftId, setNFTId] = useState(0);
  const [nftName, setNftName] = useState('SELECT CLAIM PLANET');
  const [planetImage, setPlanetImage] = useState('./images/paydirtnft/CFP_NFT_ALL.png');

  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const [fuseItems, setFuseItems] = useState<any[]>([]);
  const [totalSelected, setTotalSelected] = useState(0);
  
  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

     //test for account change
     useEffect(() => {
      setFuseItems([]);
      setItems([]);
      setTotalSelected(0);
      handleAttachContract();
    }, [account]);

    //test for planet change
    useEffect(() => {
      handleAttachContract();
    }, [paydirtNftId]);

    //test for nbr DUAL change
    useEffect(() => {
      handleAttachContract();
    }, [totalSelected]);

    //test for nbr DUAL change
    useEffect(() => {
      handleAttachContract();
    }, [nbrAlpha]);

            //test for nbr DUAL change
    useEffect(() => {
      handleAttachContract();
    }, [nbrOG]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }


    async function attachNFTContract(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        CosmicForcePaydirtNFTArtifact.abi,
        CosmicForcePaydirtNFTArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const p2eGameContract = await P2EGame.deploy('Cosmic Force','CFP');
        //await p2eGameContract.deployed();

        const nftContract = await NFT.attach(CosmicForcePaydirtNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);

        const tokenName = await nftContract.name();
        const tokenSymbol = await nftContract.symbol();
        const tokenOwner = await nftContract.owner();
        const totalSupply = await nftContract.totalSupply();

       
        setNFTContractAddr(nftContract.address);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);
        setTotalNFTSupply(Number(totalSupply));
        setTotalMinted(Number(totalSupply));

        //Chech if CFP approved and change to MINT buttin if so
        handleCheckApproveCFP();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }
  
  function handleCreateCFPNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    if (paydirtNftId == 0){
      window.alert('No Paydirt NFT Selected - SELECT PAYDIRT NFT');
      return;
    }

    async function createNFT(signer: Signer, _paydirtNftId: Number): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        CosmicForcePaydirtNFTArtifact.abi,
        CosmicForcePaydirtNFTArtifact.bytecode,
        signer
      );

      const CFP = new ethers.ContractFactory(
        CFP_Artifact.abi,
        CFP_Artifact.bytecode,
        signer
      );

      try {

        const CFP_Contract = await CFP.attach(CFP_Address.address);
      

        const amountApproved = await CFP_Contract.allowance(account, CosmicForcePaydirtNFTAddress.address);
        const balanceCFP = await CFP_Contract.balanceOf(account);

        var cost = 0;
        var costString = "0";

        if (paydirtNftId == 1) {
          //************* = 1000 with 18 )'s */
          cost = 1000000000000000000000;
          costString = "1000";
        } else if (paydirtNftId == 2) {
          //************* = 10,000 with 18 )'s */
          cost = 10000000000000000000000;
          costString = "10000";
        } else if (paydirtNftId == 3) {
          //************* = 100,000 with 18 )'s */
          cost = 100000000000000000000000; 
          costString = "100000";
        } else if (paydirtNftId == 4) {
          //************* = 1000,000 with 18 )'s */
          cost = 1000000000000000000000000;
          costString = "1000000";
        }

        // TEST ADD BACK
        if(Number(balanceCFP) < cost ) {
          window.alert('Not enough CFP balance');
          return;
        }

        if(cost == 0) {
          window.alert('No NFT Selected');
          return;
        }

        var totalCost = Math.round((cost / 1000000000000000000) * 100) / 100;
        
        //If not enough allowence left
        if (Number(amountApproved) < cost) {
          //Do Approve CFP

          const listingPrice = ethers.utils.parseEther(costString);

       // TEST ADD BACK
          const setTxn = await CFP_Contract.approve(CosmicForcePaydirtNFTAddress.address,listingPrice);
          await setTxn.wait();

          setBuyPlanetDUALButton(`MINT ${nftName} NFT WITH ${totalSelected} ${totalCost} CFP`);

          window.alert(`CFP Approve Success!`);
        }

        const nftContract = await NFT.attach(CosmicForcePaydirtNFTAddress.address);
       
        const ticker = "CFP";
        const tickerId = 1;
        const quantity = 1;

               
        // mint nft 
        // TEST ADD BACK
        await(await nftContract.mint(paydirtNftId, {
         gasLimit: 380000
      })).wait();
        // get tokenId of new nft 

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));
        setTotalMinted(Number(totalSupply));

        setBuyPlanetDUALButton(`MINT ${nftName} WITH ${totalCost} CFP`);
        handleCheckApproveCFP();

        window.alert(`Created ${nftName} MEGA MINING CLAIM NFT ID: #${totalSupply} `);

        setFuseItems([]);
        setItems([]);
        setTotalSelected(0);

        //reload page
        setLoading(true);
        handleAttachContract();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer, paydirtNftId);
  }

  function handleCheckApproveCFP(): void {
   
      // only attach when a signer is defined
      if (!signer) {
        return;
      }
  
      async function approveCheckCFP(signer: Signer, _planet: Number): Promise<void> {
        
    
          const CFP = new ethers.ContractFactory(
            CFP_Artifact.abi,
            CFP_Artifact.bytecode,
            signer
          );
    
          try {

            const CFP_Contract = await CFP.attach(CFP_Address.address);
              
            const amountApproved = await CFP_Contract.allowance(account,CosmicForcePaydirtNFTAddress.address);
            
            var cost = 0;

            if (paydirtNftId == 1) {
              //************* = 1000 with 18 )'s */
              cost = 1000000000000000000000;
            } else if (paydirtNftId == 2) {
              //************* = 10,000 with 18 )'s */
              cost = 10000000000000000000000;
            } else if (paydirtNftId == 3) {
              //************* = 100,000 with 18 )'s */
              cost = 100000000000000000000000; 
            } else if (paydirtNftId == 4) {
              //************* = 1000,000 with 18 )'s */
              cost = 1000000000000000000000000;
            }

            if (paydirtNftId == 0){
              setBuyPlanetDUALButton(`SELECT COSMIC FORCE PAYDIRT NFT TO MINT`);     
            }  else {
              //If not enough allowence left
              if (Number(amountApproved) >= cost) {
                setBuyPlanetDUALButton(`MINT ${nftName}`);
                
              } else {
                setBuyPlanetDUALButton(`APPROVE CFP & MINT ${nftName}`);
              }
            }
            
          } catch (error: any) {
            window.alert(
              'Error!' + (error && error.message ? `\n\n${error.message}` : '')
            );
          }
      }
    
    approveCheckCFP(signer, paydirtNftId);
  }


  function handlePlanetChange(_nftName: string): void {
    
    setNftName(_nftName);
    setNFTId(0);
    setPlanetImage('./images/paydirtnft/CFP_NFT_ALL.png');

    if (_nftName == 'SILVER 1,000 $CFP'){
      setNFTId(1);    
      setPlanetImage('./images/paydirtnft/CFP_1000_SILVER_1024_NFT.gif');  
    }  else if (_nftName == 'GOLD 10,000 $CFP') {
      setNFTId(2);
      setPlanetImage('./images/paydirtnft/CFP_10000_GOLD_1024_NFT.gif');
    } else if (_nftName == 'AQUA 100,000 $CFP') {
      setNFTId(3);
      setPlanetImage('./images/paydirtnft/CFP_100000_AQUA_1024_NFT.gif');
    } else if (_nftName == 'RUBY 1000,000 $CFP') {
      setNFTId(4);
      setPlanetImage('./images/paydirtnft/CFP_1000000_RUBY_1024_NFT.gif');
    }

  }
    
  return (
    <>
      
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: {NFTContractAddr}
            </h6>
            </Row>
            <Row className="g-4">
            <h1 className="text-center">
            COSMIC FORCE PAYDIRT NFT
            </h1>
            </Row>
            <Row className="g-4">
            <Col>
            <h4 className="text-center">
              Total Minted
            </h4>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            <h5 className="text-center">
              {totalMinted}
            </h5>
            </Col>
          </Row>
            <Row className="g-8">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '450px' }}>
            <img src= {planetImage} className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="p-4 text-center">
              COSMIC FORCE PAYDIRT NFT VALUES 1,000 10,000 100,000 or 1000,000 $CFP
            </h5>
          </Row>
          <Row className="g-4">
          <Col>
          </Col>
            <Col>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">Select Cosmic Force Paydirt NFT</label>
            <select onChange={(e) => handlePlanetChange(e.target.value)} className="form-control" id="FormControlQuantity">
              <option>SELECT PAYDIRT NFT</option>
              <option>SILVER 1,000 $CFP</option>
              <option>GOLD 10,000 $CFP</option>
              <option>AQUA 100,000 $CFP</option>
              <option>RUBY 1000,000 $CFP</option>
            </select>
          </div>
          </Col>
          <Col>
          </Col>
          </Row>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
            <Row className="g-4">
            <Col>
            <div className="d-grid px-8">
              <Button onClick={handleCreateCFPNFT} variant="primary" size="lg">
                {buyPLANETDUALButton}
              </Button>
            </div>
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
            
            <Col></Col>
            <Col>
            <div className="d-grid px-8">
              <Link to="/showpaydirtnft" target="_self">
              <Button variant="primary" size="lg">
              SHOW/SELL YOUR PAYDIRT NFT(s)
              </Button>
            </Link>
            </div>
            </Col>
            <Col></Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
            <h6 className="p-1 text-center">
              Holding COSMIC FORCE PAYDIRT NFTs will give a MULTIPLIER BONUS to your MINING CLAIM PAYDIRT PRODUCTION ($CFP)
            </h6>
            </Row>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            COSMIC FORCE PAYDIRT NFT RUBY - Cost/Value 1,000,000 $CFP - BONUS RATE 100%
            </h6>
            </Row>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            COSMIC FORCE PAYDIRT NFT AQUA - Cost/Value 100,000 $CFP - BONUS RATE 10%
            </h6>
            </Row>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            COSMIC FORCE PAYDIRT NFT GOLD - Cost/Value 10,000 $CFP - BONUS RATE 1%
            </h6>
            </Row>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            COSMIC FORCE PAYDIRT NFT SILVER - Cost/Value 1,000 $CFP - BONUS RATE 0.1%
            </h6>
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
